/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState ,useCallback, useMemo } from "react";
import { APIEndpoint } from "../../../utils/axios";
import { Modal, LoaderPop,DataGrid } from "../../../common";
import CustomSelect from "../../../common/CustomSelect";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { CheckInGrid } from "./checkInGrid";
import viewIcon from "../../../assets/view.svg";
import LoadingGIF from '../../../assets/loadingIn.gif';
import {getCultureFromLs,storageUtil,calculateTextWidth} from "../../../utils/commonFunctions";
import { CheckOutGrid } from "./checkOutGrid";
import DOWNLOAD_ICON from "../../../assets/icons/download-master.svg";
import { DepositSummary } from "./depositSummary";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DOWNLOAD_STATUS_CHECK_DELAY = 8000;

  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [],
    limit: 50,
    page: 1,
    searchParam: ''
  };
const actionColumnProperties = { minWidth: 130, width: 150, autoHeight: true };

const getAllowedMonths = () => {
  const months = [];
  const now = moment().startOf("month");

  for (let i = 0; i < 4; i++) {
    const m = moment(now).subtract(i, "months");
    months.push({
      key:i,
      label: m.format("MMMM YYYY"),
      value: m.format("MMMM YYYY"),   
    });
  }

  return months;
};

const actions = [
  {
    title: "Actions",
    detail: [
      { value: "viewItems", title: "View" },
      { value: "downloadItems", title: "Download" }
    ]
  }
];


const getDateRangeFromMonth = (selectedMonth) => {
  if (!selectedMonth?.value) return null;

  const m = moment(selectedMonth.value, "MMMM YYYY");

  return {
    dateFrom: m.startOf("month").format("YYYY-MM-DD"),
    dateTo: m.endOf("month").format("YYYY-MM-DD"),
  };
};

export const CashBalancePage = () => {
  const { ready } = useTranslation();

const allowedMonths = getAllowedMonths();
const [selectedMonth, setSelectedMonth] = useState(allowedMonths[0]);
const [checkInErrors, setCheckInErrors] = useState({});
  const [loadingUser, setLoadingUsers] = useState(false);
  const [crewMembersMaster, setCrewMembersMaster] = useState([]);
  const [cashDrawerList, setCashDrawerList] = useState([]);
  const [state, setState] = useState({resetDataSource:false,months:[],baseCurrency:getCultureFromLs()?.currency?.code,modalFormStatusObj:{text:""}, downloadSummaryError: false, message: null});
  const [cashDrawer, setCashDrawer] = useState(null);
  const [balanceInfo,setBalanceInfo] = useState([]);
const [selectedCashier, setSelectedCashier] = useState(null);
const [selectedLocation, setSelectedLocation] = useState(null);
const [showCheckModal, setShowCheckModal] = useState(false);
const [showDepositDetails, setShowDepositDetails] = useState(false);
const [depositLastSession, setDepositLastSession] = useState([]);
const [loading, setLoading] = useState(true);
const [cateringGroupWidth, setCateringGroupWidth] = useState({catgroupWidth:'15rem'});
const [modalMode, setModalMode] = useState(null);
const [viewBalanceInfo, setViewBalanceInfo] = useState([]);
const [viewEnabledCurrencies, setViewEnabledCurrencies] = useState([]);
const [checkInData, setCheckInData] = useState(null);
const [enabledCurrencies, setEnabledCurrencies] = useState([]);
const roundFactorRef = React.useRef(null);
const isMountedRef = React.useRef(true);
const timeoutRef = React.useRef(null);
const fetchSessionInProgressRef = React.useRef(false);

  const [drawerStatus, setDrawerStatus] = useState({status:null,location:null,user:null});
  const [employeeId] = useState(() => Number(storageUtil.get('employeeId', 'local')));
  const [employeeType] = useState(() => storageUtil.get('userType', 'local'));
const [downloadingRowId, setDownloadingRowId] = useState(null);

const isView = modalMode === "VIEW";

const gridBalanceInfo = isView ? viewBalanceInfo : balanceInfo;
const gridEnabledCurrencies = isView ? viewEnabledCurrencies : enabledCurrencies;

const sectorTitle=(mode = null)=>{
  if(selectedLocation && selectedCashier && drawerStatus && mode !== 'view'){          
return(<div className='flexRow justifyContentCenter'>
  <div className='flexRow'> 
    <div className='flexRow'>{drawerStatus?.status === "IN_USE" ? "Check-Out" : "Check-In"} - <div className='instance-member-name'>{selectedCashier.label} - {selectedLocation?.label} </div></div></div>
</div>)
  }
  else if(state && state.data){
    const {user,cashDrawer , updatedAt} = state.data;
         const tz = getCultureFromLs()?.timezone?.name;
    return(<div className='flexRow justifyContentCenter'>
  <div className='flexRow'> 
    <div className='flexRow'>Cash Drawer Check-Out Details - <div className='instance-member-name'>{updatedAt? moment(updatedAt).tz(tz).format('DD-MM-YYYY hh:mm A')+" - ":""} {user.employeeCode} - {user.employeeName} - {cashDrawer.location?.locationName} ({cashDrawer.location?.locationCode}) </div></div></div>
</div>)
  }else{
    return(<></>)
  }

}



const getActionCellIcons = useCallback((colDef, row) => {
if(!row) return [];
  return [
    {
      src: viewIcon,
      value: "viewItems",
      title: "View Checkout Details"
    },
    downloadingRowId === row?.id
      ? {
          src: LoadingGIF,
          value: "downloading",
          title: "Downloading...",
          className: "button_inrt",
          minwidth:25,
        }
      : {
          src: DOWNLOAD_ICON,
          value: "downloadItems",
          title: "Download Summary"
        }
  ];
}, [downloadingRowId]);

  const showToast = useCallback(()=>{
        toast.dismiss();

        if (state?.message?.text) {
          toast.error(state?.message?.text, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            pauseOnHover: true,
            draggable: false,
            autoClose: 2000,
            style: {
              backgroundColor: '#d9534f',
              color: '#fff',
              borderRadius: '8px',
              fontSize: '1rem',
              width:'30rem'
            }
          });
        } 
      },[state?.message])

       useEffect(() => {
          if (!state?.message?.text) return;
          showToast();
          const timer = setTimeout(() => {
            setState( (prevState) => ({
        ...prevState,
        downloadSummaryError: false,
        message: null,
      }));
        setDownloadingRowId(null);
          }, 3000);
      
          return () => clearTimeout(timer);
        }, [state?.message, showToast]); 


useEffect(() => {
  if (selectedCashier) {
   const w = calculateTextWidth(selectedCashier.label);
   setCateringGroupWidth(prev => ({...prev,catgroupWidth: `${w + 40}px`}));

  }else{
   setCateringGroupWidth(prev => ({...prev,catgroupWidth:"14rem"}));

  }
}, [selectedCashier]);

useEffect(() => {
  isMountedRef.current = true;

  return () => {
    isMountedRef.current = false;
  };
}, []);


useEffect(() => {
  return () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };
}, []);

useEffect(() => {
  setState(prev => ({
    ...prev,
    resetDataSource: !prev.resetDataSource
  }));
}, [selectedMonth?.value, cashDrawer]);


  function getDynamicHeader(title) {
  return `${title} (${state?.baseCurrency || ""})`;
}
  const fetchCashDrawers = async () => {
    try {
      const res = await APIEndpoint.get("cashRegister/cashDrawers");
  
      const list = (res.result || []).map(d => ({
        value: d.id,
        label: d.value
      }));
  
      setCashDrawerList(list)
      if (list.length === 1) {
        setCashDrawer(list[0].value);
      }
      
    } catch (error) {
      
    }
  };

  const SectorsCellRenderer = (dataMain) => {
const {user}=dataMain.data || {};

     if(user){
      return (
        <div className='flexRow justifyContentSpaceBetween'  style={{width:'100%',maxWidth:'225px',overflow:'auto'}}>
        <div className={`sector-container justifyContentFlexStart alignItemsCenter`} style={{marginRight:'1.5rem',maxWidth:'auto'}}>
          <span className="uplift-user" style={{width:'200px'}}>{user && user?.employeeCode !== user?.employeeName ?`${user?.employeeCode} -`:null} {user?.employeeName??""}</span>
        </div>
      </div>
        )
    }else{
     return null;
    }


  };

const Columns = useMemo(()=>([
  { field: 'cashDrawer.location.locationName',headerName: 'Drawer Name',valueGetter: (params) => {
      if (params.data && params.data?.cashDrawer && params.data.cashDrawer?.location) {
        const {locationCode,locationName} = params.data.cashDrawer?.location;
         return `${locationName} (${locationCode})` ;
      }
      return null;
    },tooltipField:'cashDrawer.location.locationName',flex:1, cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },suppressSizeToFit:true, resizable:true, minWidth: 140,width:190 },
  { field: 'cashier', headerName: 'Cashier',flex:1,cellRendererFramework: (params) => (
        <SectorsCellRenderer
          {...params}
          headerName={params.colDef.headerName}
        />
      ), suppressSizeToFit:true, resizable:true, minWidth: 180 },
  { field: 'checkedInBy.at', headerName: 'Check-In',flex:1, suppressSizeToFit:true, valueGetter: params => {
     const tz = getCultureFromLs()?.timezone?.name;
      return params.data?.checkedInBy?.at? tz ? moment(params.data.checkedInBy.at).tz(tz).format('DD-MM-YYYY hh:mm A') : moment(params.data.checkedInBy.at).format('DD-MM-YYYY hh:mm A'): '';
  },resizable:true, minWidth: 135 },
  { field: 'checkedOutBy.at', headerName: 'Check-Out',flex:1, suppressSizeToFit:true,valueGetter: params => {
    const tz = getCultureFromLs()?.timezone?.name;
      return params.data?.checkedOutBy?.at? tz ? moment(params.data.checkedOutBy.at).tz(tz).format('DD-MM-YYYY hh:mm A') : moment(params.data.checkedOutBy.at).format('DD-MM-YYYY hh:mm A'): '';

  }, resizable:true, minWidth: 135 },
  { field: 'openingBalanceInBaseCurrency', headerName:getDynamicHeader('Opening Balance'),flex:1,   cellStyle: (params) => {
  const val = params.data?.openingBalanceInBaseCurrency;
  if (val < 0) return { color: '#ff443dff', fontWeight: '700' };
  return null;
},
  valueGetter: (params) => {
    const val = params.data?.openingBalanceInBaseCurrency;
    return roundByFactorConverted(val); 
  },suppressSizeToFit:true, resizable:true, minWidth: 135 },
  { field: 'closingBalanceInBaseCurrency', headerName:getDynamicHeader('Closing Balance'),flex:1, cellStyle: (params) => {
  const val = params.data?.closingBalanceInBaseCurrency;
  if (val < 0) return { color: '#ff443dff', fontWeight: '700' };
  return null;
},
  valueGetter: (params) => {
    const val = params.data?.closingBalanceInBaseCurrency;
    return roundByFactorConverted(val); 
  }, suppressSizeToFit:true, resizable:true, minWidth: 135 },

]),[state.baseCurrency])




  useEffect(() => {
    if (!ready) return;

    const init = async () => {
      await fetchCashDrawers();
      setLoading(false);
    };

    init();
    getEmployeesAll();
    fetchCurrencies();
  }, [ready]);

  useEffect(() => {
    renderActionButton();
  }, [selectedCashier]);

useEffect(() => {

  if (crewMembersMaster.length && employeeId) {
    setSelectedCashier(crewMembersMaster.find(crw => crw.key === employeeId) || null);
  }else{
     setSelectedCashier(null);
  }
}, [crewMembersMaster, employeeId]);

    useEffect(() => {
    setCheckInErrors({});
          setState(prev => ({
          ...prev,
          modalFormStatusObj: { text: '' }
        }));
  }, [checkInData]);

async function fetchEmployees(page=1, perPage=1,searchKey=''){
  filterData.page = page;
  filterData.limit = perPage;
  filterData.searchParam = searchKey;
  try {
    const res=await APIEndpoint.post('employees/process',filterData);
    return res;
  } catch (error) {
    console.error("Failed to fetch employees:", error);
  }
}


const getEmployeesAll = useCallback(async () => {
  setLoadingUsers(true);
  try {
    const initialRes = await fetchEmployees(1, 1);
    const total = initialRes?.count || 0;

    if (total > 0) {
      const fullRes = await fetchEmployees(1, total);

      if (Array.isArray(fullRes?.items) && fullRes.items.length) {
        const formattedEmployees = fullRes.items.map((item, index) => ({
          key: item.employeeId,
          label: `${item.employeeCode} - ${item.name}`,
          value: item.employeeCode,
        }));
        setCrewMembersMaster(formattedEmployees);
      }
    }
  } catch (error) {
    console.error("Failed to fetch employees:", error);
  } finally {
    setLoadingUsers(false);
  }
}, []);

const fetchCurrencies = useCallback(async () => {
  if(roundFactorRef.current) return;
   try {
    const homeCurrency = getCultureFromLs()?.currency?.code;
    const res = await APIEndpoint.get('/currencies');
  if (res && Array.isArray(res.items) && res.items?.length) {
  const roundFactor = res.items.find(c => c.code === homeCurrency)?.roundingFactor;
  roundFactorRef.current = roundFactor;
  }
  } catch (error) {
    console.error("Failed to fetch:");
  }
}, []);

useEffect(() => {
  fetchActiveSession(cashDrawer);
}, [cashDrawer]);

const roundByFactorConverted = useCallback((amount) => {
  if (amount === null || amount === undefined || amount === "") return "";

  const num = Number(amount);
  if (isNaN(num)) return "";

  const factor = Number(roundFactorRef.current);

  let roundedValue;

  if (!Number.isFinite(factor) || factor <= 0) {
    roundedValue = num;
  } else {
    roundedValue =
      Math.round((num + Number.EPSILON) / factor) * factor;
  }
  return roundedValue.toFixed(2);
}, []);

const fetchActiveSession = async (cId) => {
  if (!cId) return;
  try {
  
    const res = await APIEndpoint.get(
      `cashRegister/cashDrawers/${cId}`
    );

    const drawer = res?.cashDrawer;
    if (!drawer) return;

    setDrawerStatus(_=>({..._,status:drawer?.status,location:drawer?.location ?`${drawer?.location?.locationName} (${drawer?.location?.locationCode})`:null,user:drawer.lock ?`${drawer.lock?.userName}`:null}));

    const baseCurrency = state?.baseCurrency;
    const enabledCurrencies = drawer.enabledCurrencies || [];

    const sortedEnabled = [
      ...enabledCurrencies.filter(c => c.currencyCode === baseCurrency),
      ...enabledCurrencies.filter(c => c.currencyCode !== baseCurrency)
    ];

    const currentBalance = Array.isArray(drawer.currentBalance)
      ? drawer.currentBalance
      : [];
    const depositCheck = Array.isArray(drawer.lastSessionDeposits)
      ? drawer.lastSessionDeposits.map((drw)=>({...drw,amount:roundByFactorConverted(drw.amount)}))
      : [];

    const  sortedDeposits = [...depositCheck?.filter(c=>c.currencyCode === baseCurrency),...depositCheck?.filter(c=>c.currencyCode !== baseCurrency)]

    const balanceMap = currentBalance.reduce((acc, b) => {
     acc[b.currencyCode] = {
        amount: b.amount ?? 0,
        remark: b.remark ?? "",
        discrepancy:b.varianceAcknowledged ?? false
      };
      return acc;
    }, {});

    const enabledCodes = new Set(
      sortedEnabled.map(c => c.currencyCode)
    );

    const extraCurrencies = currentBalance
      .filter(b => !enabledCodes.has(b.currencyCode))
      .map(b => ({ currencyCode: b.currencyCode }));

    const finalCurrencies = [
      ...sortedEnabled,
      ...extraCurrencies
    ];

    setEnabledCurrencies(finalCurrencies);

    const mergedBalanceInfo = finalCurrencies.map((c, index) => ({
      key: index,
      currencyCode: c.currencyCode,
      amount: balanceMap[c.currencyCode]?.amount ?? 0,
      remark: balanceMap[c.currencyCode]?.remark ?? "",
      discrepancy: balanceMap[c.currencyCode]?.discrepancy ?? false

    }));
      const sortedBalanceInfo = [...mergedBalanceInfo].sort((a, b) => {

        if (a.currencyCode === baseCurrency && b.currencyCode !== baseCurrency) {
          return -1;
        }
        if (a.currencyCode !== baseCurrency && b.currencyCode === baseCurrency) {
          return 1;
        }

        const aHasAmount = Number(a.amount) !== 0;
        const bHasAmount = Number(b.amount) !== 0;

        if (aHasAmount && !bHasAmount) return -1;
        if (!aHasAmount && bHasAmount) return 1;

        return 0;
      });
    if (!isMountedRef.current) return;
    setBalanceInfo(sortedBalanceInfo);
    setDepositLastSession(sortedDeposits);

  } catch (err) {
    if (!isMountedRef.current) return;
    console.error("Failed to fetch cash drawer");
  }
};


const fetchCashBalance = useCallback(
  async (page = 1, perPage = 50) => {
const { dateFrom, dateTo } = getDateRangeFromMonth(selectedMonth) || {};

    const payload = {
      page,
      limit: perPage,
       ...(employeeType!=="admin" ?{ userId: employeeId }:{}),
          ...(dateFrom && { dateFrom: dateFrom }),
          ...(dateTo && { dateTo: dateTo }),
          ...(cashDrawer && { cashDrawerId: cashDrawer }),
    };

    try {
      const res = await APIEndpoint.post(
        'cashRegister/cashDrawers/sessions/list',
        payload
      );
      return res;
    } catch (error) {
    
    }
  },
  [selectedMonth?.value,cashDrawer]
);


const renderActionButton = () => {
  if (!cashDrawer || !selectedCashier) return null;

  return (
    <button
      className="add-item-button"
      onClick={() => {
  setModalMode(drawerStatus?.status === "IN_USE" ? "CHECK_OUT" : "CHECK_IN");
  setShowCheckModal(true);
}}
    >
      {drawerStatus?.status === "IN_USE" ? "Check-Out" : "Check-In"}
    </button>
  );
};

const validateCheckInData = (rows) => {
  const errorMap = {};

  rows.forEach((row, index) => {
    const system = Number(row.systemValue);
    const final = Number(row.finalValue);

    if (row.discrepancy) {
      if (row.finalValue === "" || row.finalValue === null) {
        errorMap[index] = errorMap[index] || [];
        errorMap[index].push("*Final value is required");
      }

      if (!row.remarks || !row.remarks.trim()) {
        errorMap[index] = errorMap[index] || [];
        errorMap[index].push("*Remarks is required");
      }

      return;
    }

    const hasFinal =
      row.finalValue !== "" && row.finalValue !== null;

    if (
      hasFinal &&
      !Number.isNaN(system) &&
      !Number.isNaN(final) &&
      system !== final
    ) {
      errorMap[index] = errorMap[index] || [];
      errorMap[index].push("*Checking is mandatory");

      if (!row.remarks || !row.remarks.trim()) {
        errorMap[index].push("*Remarks required");
      }
    }
  });

  return errorMap;
};






const enableButtons = (submitBtnObj, cancelButtonObj) => {
  submitBtnObj?.removeAttribute('disabled');
  if(cancelButtonObj){
  cancelButtonObj?.removeAttribute('disabled');
  }
};

const handleSessions = async (checkIn = false) => {
  
  if (!checkInData?.rows || !selectedCashier || !cashDrawer) return;

  const submitBtnObj = document.getElementsByClassName('done-button')[0];
  submitBtnObj?.setAttribute('disabled', 'true');

  const errorMap = validateCheckInData(checkInData.rows);

  if (Object.keys(errorMap).length > 0) {
    setCheckInErrors(errorMap); 

    enableButtons(submitBtnObj, null);
    return;
  }

  setCheckInErrors({});
  const confirmedBalance = checkInData.rows
    .map(r => ({
      currencyCode: r.currency,
      amount: r.finalValue!==""? Number(r.finalValue):"",
      remark: r.remarks,
      varianceAcknowledged: r.discrepancy
    }));

const payload = {
  cashDrawerId: cashDrawer,
  ...(
    employeeType === "admin" && !checkIn
      ? {} 
      : { cashierId: Number(selectedCashier.key) }
  ),
  confirmedBalance
};
try {
 const res = checkIn ? await APIEndpoint.post("cashRegister/cashDrawers/sessions/start",payload):await APIEndpoint.post("cashRegister/cashDrawers/sessions/end",payload);
if(res && res?.message){

 setState(prev => ({
          ...prev,
          modalFormStatusObj: { text: res.message }
        }));
        
    timeoutRef.current =  setTimeout(() => {
       if (!isMountedRef.current) return;
        setState(prev => ({
          ...prev,
          resetDataSource: !prev.resetDataSource,
          modalFormStatusObj: { text: '' }
        }));
        setShowCheckModal(false);
        setCheckInData(null);
        setCheckInErrors({});
        fetchActiveSession(cashDrawer);
        enableButtons(submitBtnObj,null);
      }, 2500);
}
  
} catch (error) {
     const errorMessage =
        error?.message
          ? JSON.parse(error.message)?.data?.message
          : 'Failed to check-In';

      setState(prev => ({
        ...prev,
        modalFormStatusObj: { error: errorMessage }
      }));
       enableButtons(submitBtnObj,null);
}
};




  if (loading) {
    return <LoaderPop />;
  }
async function fetchSessionDetails(sId) {
  if (fetchSessionInProgressRef.current) return false;
  fetchSessionInProgressRef.current = true;

  try {
    const res = await APIEndpoint.get(
      `cashRegister/cashDrawers/sessions/${sId}/details`
    );

    const { closingAudit } = res?.session || {};
    if(!closingAudit){
        return false;
    }
    const baseCurrency = state?.baseCurrency;

    const systemBalance = Array.isArray(closingAudit?.systemBalance)
      ? closingAudit.systemBalance
      : [];

    const confirmedBalance = Array.isArray(closingAudit?.confirmedBalance)
      ? closingAudit.confirmedBalance
      : [];


    const systemMap = systemBalance.reduce((acc, b) => {
      acc[b.currencyCode] = b.amount ?? 0;
      return acc;
    }, {});

    const confirmedMap = confirmedBalance.reduce((acc, b) => {
      acc[b.currencyCode] = {
        finalValue: b.amount ?? "",
        drawValue: b.amount ?? "",
        remark: b.remark ?? "",
        discrepancy: b.varianceAcknowledged ?? false
      };
      return acc;
    }, {});

    const currencyCodes = Array.from(
      new Set([
        ...systemBalance.map(b => b.currencyCode),
        ...confirmedBalance.map(b => b.currencyCode)
      ])
    );

    const sortedCodes = [
      ...currencyCodes.filter(c => c === baseCurrency),
      ...currencyCodes.filter(c => c !== baseCurrency)
    ];

    const finalCurrencies = sortedCodes.map(code => ({
      currencyCode: code
    }));

    setViewEnabledCurrencies(finalCurrencies);
    const mergedBalanceInfo = finalCurrencies.map((c, index) => ({
      key: index,
      currencyCode: c.currencyCode,
      amount: systemMap[c.currencyCode] ?? 0,
      finalValue: confirmedMap[c.currencyCode]?.finalValue ?? "",
      drawValue: confirmedMap[c.currencyCode]?.drawValue ?? "",
      remark: confirmedMap[c.currencyCode]?.remark ?? "",
      discrepancy: confirmedMap[c.currencyCode]?.discrepancy ?? false
    }));


    const sortedBalanceInfo = [...mergedBalanceInfo].sort((a, b) => {
      if (a.currencyCode === baseCurrency && b.currencyCode !== baseCurrency)
        return -1;
      if (a.currencyCode !== baseCurrency && b.currencyCode === baseCurrency)
        return 1;

      const aHasAmount = Number(a.amount) !== 0;
      const bHasAmount = Number(b.amount) !== 0;

      if (aHasAmount && !bHasAmount) return -1;
      if (!aHasAmount && bHasAmount) return 1;

      return 0;
    });

    setViewBalanceInfo(sortedBalanceInfo);
    return true;
  } catch (err) {
    console.error("Failed to fetch session details", err);
    setViewEnabledCurrencies([]);
    setViewBalanceInfo([]);
    return false;
  }finally{
    fetchSessionInProgressRef.current = false;
  }
}

  const handleAction = async (e, action, rowData) => {
    if (action?.value === "viewItems") {
      if (fetchSessionInProgressRef.current) return;
      if(!rowData?.id) {
        setState((_) => {
        return { ..._,message: { 
          text:"Cannot view details of an active session."
        }, };
      });
      return;
      };
      const res =  await fetchSessionDetails(rowData.id);
    if(res){
      setState((_) => {
        return { ..._,data:rowData};
      });
    setModalMode("VIEW");
    setShowCheckModal(true);
     }else{
       setState((_) => {
        return { ..._,message: { 
          text:"Cannot view details of an active session."
        }, };
      });
    }
      // View action logic here   
    }
    if (action?.value === "downloadItems") {

      if (downloadingRowId) {
        return;
      }
      if (!rowData || !rowData.id) {
        setDownloadingRowId(rowData.id);
                                           setState((_) => {
        return { ..._, downloadSummaryError: true, message: { 
          text:"Invalid session data for download."
        }, };
      });
     
        return;
      }
      if ( !rowData.sessionClosingAuditId || !rowData.checkedOutBy ) {
        setDownloadingRowId(rowData.id);
         setState((_) => {
        return { ..._, downloadSummaryError: true, message: { 
          text:"Cannot download summary for an active session."
        }, };
      });
        
        return;
      }
      
      await onDownloadDrawerCheckoutSummaryReport(e, rowData);
    }
  };

  const onDownloadDrawerCheckoutSummaryReport = async(e, row)=>{
      const headers = {
        'Accept':'text/csv'
      };
  
      try {
        setDownloadingRowId(row?.id);
  
        const res= await APIEndpoint.post(`cashier/download/drawerCheckoutSummary`, { 
            reportType: 'drawerCheckoutSummary',
            sessionId: row.id 
        }, headers);

        if(res.status==='scheduled') {
  
          setTimeout(() => {
            const downloadPromise = APIEndpoint.get(`downloads/status/${res.id}`);
            downloadPromise.then( (val) => {
  
              if (val.status === "completed") {
  
                APIEndpoint.get(`downloads/analytics/${val.fileName}${val.fileExtension}`)
                  .then((DownloadResp) => {
                    const url = window.URL.createObjectURL(new Blob([DownloadResp]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `Drawer_Checkout_Summary_Report-${new Date().toISOString().replace(/:/g, '-')}${val.fileExtension}`);
                    document.body.appendChild(link);
                    link.click();
                    setDownloadingRowId(null);
                  })
                  .catch((error) => {
                    console.error('Log: Error downloading file:', error);
                        setDownloadingRowId(null);
                    const errorTxt = JSON.parse( error?.message );
                                   setState((_) => {
        return { ..._, downloadSummaryError: true, message: { 
          text: errorTxt?.data?.message || "Something went wrong. Please try again after some time."
        }, };
      });
                  
                  });
              }
              else if (val.status === "failed") {
                    setDownloadingRowId(null);

               setState((_) => {
        return { ..._, downloadSummaryError: true, message: { 
          text: val?.data?.message || "Something went wrong. Please try again after some time."
        }, };
      });
            
              }
              else {
                console.error('Log: Retry download again after some time.');
                    setDownloadingRowId(null);

               setState((_) => {
        return { ..._, downloadSummaryError: true, message: { 
          text: "Something went wrong. Please try again after some time."
        }, };
      });
          

              }
            })
            .catch( (error) => {
              console.error('Log: Error while checking download status:', error);
                  setDownloadingRowId(null);
              const errorTxt = JSON.parse( error?.message );

               setState((_) => {
        return { ..._, downloadSummaryError: true, message: { 
          text: errorTxt?.data?.message || "Something went wrong. Please try again after some time."
        }, };
      });
            });
  
          }, DOWNLOAD_STATUS_CHECK_DELAY);
        }
      }
      catch (error) {
            setDownloadingRowId(null);
        console.error('Log: Error while downloading:', error);
        const errorTxt = JSON.parse( error?.message ); 
      setState((_) => {
        return { ..._, downloadSummaryError: true, message: { 
          text: errorTxt?.data?.message || "Something went wrong. Please try again after some time."
        }, };
      });
      }
    }


  return (
    <div className="flexCol width100 ag-theme-alpine-dark cash-reg">

         <div className='flexCol full-flex'>
      <div className="flexRow alignItemsCenter justifyContentSpaceBetween margBottm20">
<div className="flexRow justifyContentFlexStart">
        <div className='margTop10 margRight10'>
          <CustomSelect
          placeHolder="Select Month"
          options={allowedMonths}
          value={selectedMonth}
          onChange={(e) => {
          setSelectedMonth(e);

          }}
          />

          </div>

        {(
          <div className='margLeft6 margTop10 margRight10'>
          <CustomSelect
          placeHolder="Select Drawer"
          options={cashDrawerList}
          onChange={(e) => {
          setCashDrawer(e?.value);
          setSelectedLocation(e);
          }}
          />
          </div>
        )}
       
          <div className='flexRow alignItemsCenter justifyContentCenter margLeft6 margTop10 margRight10'>
            
            <CustomSelect
            placeHolder="Select Cashier"
            options={crewMembersMaster}
            width={cateringGroupWidth.catgroupWidth}
            isDisabled={loadingUser}
            value={selectedCashier}
            onChange={(e) => setSelectedCashier(e)}
            />
          {loadingUser ?<img src={LoadingGIF} className='' style={{width:'16px',height:'16px',marginLeft:'2px'}} alt="Loading" />:<></>}

          </div>
        


</div>
        {renderActionButton()}
      </div>
             <DataGrid
            className="full-flex"
            columns={[...Columns]}
            initialPageLimit={50}
            actionProperties={actionColumnProperties}
            showDefaultFilters={false}
            getRows={fetchCashBalance}
            rowSelection="multiple"
            actions={actions}
            getActionCellIcons={getActionCellIcons}
            onAction={ handleAction }
            columnResize={true}
            resetDataSource={state.resetDataSource}
          />
         </div>
   

{showCheckModal && roundFactorRef?.current!==null &&  (
<Modal
  TitleComponent={modalMode === "VIEW" ? ()=>sectorTitle('view') : ()=>sectorTitle('create')}
  buttonLabel={modalMode === "VIEW" ? 'Done' : "Save"}
  modalFormStatusObj={state.modalFormStatusObj}
  onSubmit={
    modalMode === "VIEW"
      ? () => {
    setShowCheckModal(false);
    setModalMode(null);
    setViewEnabledCurrencies([]);
    setViewBalanceInfo([]);
  }
      : () => handleSessions(drawerStatus?.status !== "IN_USE")
  }
  onClose={() => {
    setShowCheckModal(false);
    setModalMode(null);
    setCheckInErrors({});
    setCheckInData(null);
  }}
>
    {drawerStatus?.status === "IN_USE" ? (
<CheckOutGrid
  cashDrawerId={cashDrawer}
  date={moment().startOf("month").toDate()}
  balanceInfo={gridBalanceInfo}
  drawerStatus={drawerStatus}
  roundFactor={roundFactorRef.current}
  disabledDeposits={!Boolean(depositLastSession?.length)}
  enabledCurrencies={gridEnabledCurrencies}
  setShowDepositDetails={setShowDepositDetails}
  onChange={setCheckInData}
  readOnly={modalMode === "VIEW"}
  errorsValidated={checkInErrors}
/>
    ) : (
<CheckInGrid
  cashDrawerId={cashDrawer}
  date={moment().startOf("month").toDate()}
  balanceInfo={gridBalanceInfo}
  roundFactor={roundFactorRef.current}
  drawerStatus={drawerStatus}
  disabledDeposits={!Boolean(depositLastSession?.length)}
  setShowDepositDetails={setShowDepositDetails}
  enabledCurrencies={gridEnabledCurrencies}
  onChange={setCheckInData}
  readOnly={modalMode === "VIEW"}
  errorsValidated={checkInErrors}
/>
    )}
  </Modal>
)}

{showCheckModal && showDepositDetails && Array.isArray(depositLastSession) && depositLastSession.length > 0 &&  (
  <Modal
     TitleComponent={sectorTitle}
     mainContentCenter={true}
     onSubmit={()=>{ 
      setShowDepositDetails(false);
     }}
    onClose={() =>{ 
      setShowDepositDetails(false);
     }
    }
  >
<DepositSummary checkInData={depositLastSession}/>
    
  </Modal>
)}
 <ToastContainer  position="top-center"  
  hideProgressBar={true}
   toastStyle={{ fontSize: '1rem' }} 
  newestOnTop={true}
  rtl={false}
  pauseOnFocusLoss={false}
  draggable={false}
  pauseOnHover ={false}
  />
  
    </div>
  );
};
